import { FC, useEffect, useState } from "react"
import { IconButton, MenuItem, MenuList, Paper } from "@mui/material"
import { viewControlInTreatment } from "@/gluelayer"
import DialogBox from "../bottom/DialogBox/dialogBox"
import { UButton } from "@/components/index"
import domeSyncIcon from "../../UDTreat/assets/dome_pontic/domeSync.png"
import lockIcon from "../../UDTreat/assets/dome_pontic/static_dome_lock.png"

export const UDStaticDomeButton: FC = () => {
  const [data, setData] = useState({
    bShow: false,
    isLocked: false,
    posX: 0,
    posY: 0
  })

  const handleUpdateDomeSyncBtnStatus = (bShow:boolean, isLocked:boolean, posX:number, posY:number) => {
    console.log('UpdateDomeSyncBtnStatus:', bShow, isLocked, posX, posY)
    setData({
      bShow,
      isLocked,
      posX,
      posY
    })
  }

  const handleSyncButtonClicked = () => {
    viewControlInTreatment.OnSyncButtonDown()
  }

  useEffect(() => {
    viewControlInTreatment.setUpdateDomeSyncBtnStatusCallback(handleUpdateDomeSyncBtnStatus)
    // 清理函数
    return () => {
      viewControlInTreatment.setUpdateDomeSyncBtnStatusCallback(null)
    }
  }, [])

  return (
    <>
      {data.bShow &&
        <Paper elevation={0} sx={{
          position: 'absolute',
          left: data.posX,
          top: data.posY,
          borderRadius: 1,
          overflow: 'hidden',
          bgcolor: 'transparent',
        }}>
          {data.isLocked ? (
            <IconButton onClick={() => {}} sx={{ p: 0, bgcolor: 'transparent', '&:hover': { bgcolor: 'transparent' }, '&:focus': { bgcolor: 'transparent' }, '&:active': { bgcolor: 'transparent' } }}>
              <img src={lockIcon} alt="Lock" style={{ display: 'block' }} />
            </IconButton>
          ) : (
            <IconButton onClick={() => {handleSyncButtonClicked()}} sx={{ p: 0, bgcolor: 'transparent', '&:hover': { bgcolor: 'transparent' }, '&:focus': { bgcolor: 'transparent' }, '&:active': { bgcolor: 'transparent' } }}>
              <img src={domeSyncIcon} alt="Sync" style={{ display: 'block' }} />
            </IconButton>
          )}
        </Paper>
      }

    </>
  )
}